// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.renter.GetRenterStatusWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetRenterStatusWebApiRequestDto, GetRenterStatusWebApiResponseDto } from '../..';

export const GetRenterStatusWebApiHandler_getRenterStatus_Path = '/api/web/v1/renter/getRenterStatus';

/**
 * get renter status
 */
export const GetRenterStatusWebApiHandler_getRenterStatus = (
  postData: GetRenterStatusWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GetRenterStatusWebApiRequestDto, GetRenterStatusWebApiResponseDto>(
    {
      endpoint: GetRenterStatusWebApiHandler_getRenterStatus_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
